// frontend/src/components/Welcome.js
import React, { useEffect, useRef } from 'react';

const Welcome = ({ onDismiss, onClose }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleEsc = (event) => {
       if (event.key === 'Escape') {
        onClose();
       }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
        window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  const handleBackdropClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  return (
    <div onClick={handleBackdropClick} style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1001
    }}>
      <div ref={modalRef} style={{
        backgroundColor: 'white',
        paddingTop: '2rem',
        paddingBottom: '2rem',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        borderRadius: '8px',
        maxWidth: '800px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <button onClick={onDismiss} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '0.85rem', padding: '4px 8px' }}>Never show</button>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', fontSize: '0.85rem', padding: '4px 8px', fontWeight: 600 }}>Close</button>
        </div>
        <h2 style={{ margin: 0 }}>Welcome to SqueakBase!</h2>
        <p>This guide will walk you through the basics of using the application.</p>

        <hr style={{ margin: '1.5rem 0' }} />

        <h3>Mice Management</h3>
        <div style={{
          padding: '2px',
          borderRadius: '4px',
          margin: '1rem 0',
          textAlign: 'left',
        }}>
          <img src="SB_MM.PNG" style={{ maxWidth: '100%', height: 'auto' }}/>
          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>A view of the main Mice Management dashboard.</p>
        </div>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Adding Mice:</strong> Click the "Add New Mouse" button to open a form where you can input details like physical tags, sex, date of birth, and genotype.</li>
          <li><strong>Editing Mice:</strong> Click the "Edit" button on any mouse record to update its information.</li>
          <li><strong>Archiving Mice:</strong> Instead of deleting, you can archive mice. This removes them from the active list but preserves their data.</li>
          <li><strong>Searching Mice:</strong> On any page in SqueakBase, you can search multiple things as comma separated values. </li>
        </ul>

        <hr style={{ margin: '1.5rem 0' }} />

        <h3>Data Import</h3>
        <div style={{
          padding: '2px',
          borderRadius: '4px',
          textAlign: 'left',
        }}>
          <img src="SB_Import.PNG" style={{ maxWidth: '100%', height: 'auto' }}/>
          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>The "Import Excel" button on the Mice Management page.</p>
        </div>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Import:</strong> The importer is designed to be directly compatible with mouse records exported from other mouse management software. Simply export your data from SoftMouse and import it here.</li>
          <li><strong>Template:</strong> The import window will show you the expected column format for a successful import.</li>
        </ul>

        <hr style={{ margin: '1.5rem 0' }} />

        <h3>Cage Management</h3>
        <div style={{
          padding: '2px',
          borderRadius: '4px',
          textAlign: 'left',
        }}>
          <img src="SB_Cage.PNG" style={{ maxWidth: '100%', height: 'auto' }}/>
          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>The Cage Management view, showing details of each cage.</p>
        </div>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Breeding Status:</strong> Cages can be marked as 'Breeding' or 'Stock' to help you organize your colony.</li>
          <li><strong>Adding Litters:</strong> For breeding cages, you can directly add a new litter from the Cage Management screen.</li>
        </ul>

        <hr style={{ margin: '1.5rem 0' }} />

        <h3>Litter Management</h3>
        <div style={{
          padding: '2px',
          borderRadius: '4px',
          textAlign: 'left',
        }}>
          <img src="SB_LM.PNG" style={{ maxWidth: '100%', height: 'auto' }}/>
          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>The Cage Management view, showing details of each cage.</p>
        </div>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Editing Litters:</strong> Adjust the number of pups in a litter by clicking "Edit"</li>
          <li><strong>Managing Litters:</strong> Assign the genotype, sex, and physical tag in "Manage".</li>
          <li><strong>Wean Litters:</strong> Put animals into their respective cages with "Wean". </li>
        </ul>

        <hr style={{ margin: '1.5rem 0' }} />


        <h3>Settings</h3>
        <div style={{
          padding: '2px',
          borderRadius: '4px',
          textAlign: 'left',
        }}>
          <img src="SB_SM.PNG" style={{ maxWidth: '100%', height: 'auto' }}/>
          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>The main Settings view.</p>
        </div>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Email Reminders:</strong> Set up custom email reminders for events like weaning dates based on specific criteria you define.</li>
          <li><strong>Lab Management:</strong> If you are part of a lab, you can manage members and switch between your personal view and the lab view to see shared data.</li>
        </ul>


      </div>
    </div>
  );
};

export default Welcome;